import React, { useState, useEffect } from 'react'
import Loader from '../../component/loader/Loader'
import { useDispatch, useSelector } from 'react-redux';
import { OrderListRes, OrderListTodo } from '../../redux/Slices/Orders/OrderList';
import DataTable from '../../component/data_table/DataTable';
import { RiComputerLine } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { IoRefreshOutline } from 'react-icons/io5'
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import { LuFileEdit, LuTrash2 } from 'react-icons/lu';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'
import DataTablePagination from '../../component/data_table/DataTablePagination';
import { useFormik } from 'formik';
import SaveButton from '../../component/buttons/SaveButton';
import DeleteOrder from './DeleteOrder';
import { SalesOrderPdfRes, SalesOrderPdfTodo } from '../../redux/Slices/Orders/SalesOrderPdf';
import { toast, ToastContainer } from 'react-toastify';


export default function SalesOrderList() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [bool, setBool] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLimit, setPageLimit] = useState(10)
  const [tableLoading, setTableLoading] = useState(false)
  const [pageSize, setPageSize] = useState(1)
  const [deleteModal, setDeleteModal] = useState(false)
  const [orderData, setOrderData] = useState(false)
  const [filterLoad, setFilterLoad] = useState(false)
  const orderList = useSelector(state => state?.OrderList?.data?.data)
  // const TotalCount = useSelector(state => state?.OrderList?.data?.list_size)

  console.log('pageSize', pageSize)

  const initialValues = {
    search: '',
    fromDate: '',
    toDate: ''
  }


  const order_edit = (data) => {
    navigate('../add-order', { state: data })
  }

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: initialValues,

    onSubmit: (values, action) => {

      setFilterLoad(true)
      dispatch(OrderListTodo({ "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate, "pageLimit": pageLimit, "pageSize": pageSize })).then(() => filter_res())
    }
  })
  const handleReset = () => {
    setFieldValue('fromDate', ""); // Reset fromDate
    setFieldValue('toDate', "");   // Reset toDate
    values.date = ''   // Reset date
    setFieldValue('search', "");   // Reset search
    setBool(!bool);                // Toggle bool state if necessary
  };

  const filter_res = () => {
    if (OrderListRes && OrderListRes.success) {
      setFilterLoad(false)
    } else {
      setFilterLoad(false)
    }
  }

  const handleSearch = (data) => {
    setTableLoading(true)
    dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": data, "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => filter_res2())
  }

  const PageSizeFun = (data) => {
    setTableLoading(true)
    setPageLimit(data)
    dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => filter_res2())
  }

  const nextPageFun = () => {
    setTableLoading(true)
    setPageSize(prev => prev + 1);
    dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => filter_res2())
  }
  const prevPageFun = () => {
    setTableLoading(true)
    setPageSize(prev => prev - 1);
    dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => filter_res2())
  }
  
  const filter_res2 = () => {
    if (OrderListRes && OrderListRes.success) {
      setTableLoading(false)
    } else {
      setTableLoading(false)
    }
  }

  useEffect(() => {
    dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate, }))
  }, [pageLimit, pageSize])

  useEffect(() => {
    setLoading(true)
    dispatch(OrderListTodo({ "pageLimit": pageLimit, "pageSize": pageSize, "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => orderListFun())
  }, [bool])

  const orderListFun = () => {
    if (OrderListRes && OrderListRes.success) {
      setLoading(false)
    } else {
      setLoading(false)
    }
  }

  const OrderDelete = (e) => {
    setDeleteModal(true)
    setOrderData(e)
  }

  const pdfGenrate = (data) => {
    setFilterLoad(true)
    dispatch(SalesOrderPdfTodo(data.vpurchase_order_code)).then(() => pdf_res())
  }

  const pdf_res = () => {
    if (SalesOrderPdfRes && SalesOrderPdfRes.status) {
      setFilterLoad(false)
      toast.success(SalesOrderPdfRes?.message, { position: "bottom-right" });
      setTimeout(() => {
        window.open(SalesOrderPdfRes?.return_file, '_blank');
      }, 1500);


    } else {
      setFilterLoad(false)
      toast.error(SalesOrderPdfRes?.message, { position: "bottom-right" });
    }
  }


  const columnDefs = [
    {
      headerName: 'S.NO',
      field: 'filedName',
      valueGetter: `${pageLimit * pageSize} + (node.rowIndex + 1) - ${pageLimit}`,
      filter: 'false',
      suppressMenu: true,
      sortable: true,
      floatingFilter: false,
      // wrapText: true,
      // autoHeight: true,
      maxWidth: 70
    },
    {
      headerName: 'SO CODE',
      field: 'vpurchase_order_code',
      cellRenderer: params => <span onClick={() => pdfGenrate(params?.data)} style={{ fontSize: '16px', fontWeight: "600", color: 'red', cursor: 'pointer' }}>{params?.data?.vpurchase_order_code}</span>,
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: false,
      maxWidth: 150
      // wrapText: true,
      // autoHeight: true,
    },
    {
      headerName: 'SO DATE',
      field: 'dpo_date1',
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: false,
      maxWidth: 150

      // wrapText: true,
      // autoHeight: true,
    },


    {
      headerName: 'CUST NAME',
      field: 'vplant_name',
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: false,
      width: 320
      // wrapText: true,
      // autoHeight: true,

    },
    {
      headerName: 'FINANCE STATUS',
      field: 'vstatus',
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: false,
      // wrapText: true,
      // autoHeight: true,
      maxWidth: 150
    },
    {
      headerName: 'PRICE STATUS',
      field: 'vprice_status',
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: false,
      // wrapText: true,
      // autoHeight: true,
      maxWidth: 150
    },
    {
      headerName: 'CITY',
      field: 'vcustomer_plant_city',
      filter: 'agTextColumnFilter',
      suppressMenu: true,
      filter: true,
      sortable: true,
      floatingFilter: false,
      // wrapText: true,
      // autoHeight: true,
      maxWidth: 130
    },


    {
      field: 'ACTIONS',
      cellRenderer: params =>
        // params.data.cstatus === 'P' ? 
        <div>
          <LuFileEdit style={{ color: 'green' }} size={20} className='ms-1'
            onClick={() => order_edit(params.data)}
          />
          {params.data.vdespatch_advice_no == null || params.data.vdespatch_advice_no == '' ? <LuTrash2 style={{ color: "red" }} size={20} className=' ms-3'
            onClick={() => OrderDelete(params.data)}
          /> : ''}
        </div>

      ,
      wrapText: true,
      autoHeight: true,
      pinned: 'right',
      maxWidth: 100
    }
  ]

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">

            <div className='layout_head'>
              <h5> Sales Order List</h5>
            </div>
            {loading ?
              <div className='mt-5 pt-5'>
                <Loader />
              </div>
              :
              <div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor="" className='form_label'>Search </label>
                      <input
                        type="text"
                        id="filter-text-box"
                        name='search'
                        // onChange={(e) => handleSearch(e.target.value)}
                        value={values.search}
                        onChange={(e) => {
                          setFieldValue('search', e.target.value);
                          handleSearch(e.target.value)
                        }}
                        className="form-control form_input"
                        onBlur={handleBlur}
                      />
                    </div>
                    {/* <div className="col-md-3">
                  <label htmlFor="" className='form_label'>From Date to To Date</label>
                  <Flatpickr
                    className='form-control form_input '

                    options={{
                      altInput: false,
                      altFormat: "",
                      dateFormat: 'd-m-Y',
                      minDate: '', // Sets the minimum date to today
                      maxDate: '', // No maximum date specified
                      mode: "range", // Enables range selection
                      disable: [], // No dates disabled
                      defaultDate: [], // No default date
                      conjunction: "", // Separator for range mode
                      static: true // Makes the calendar always visible

                    }}
                    name='date'
                    onChange={(e) => {
                      setFieldValue('fromDate', moment(e[0]).format("DD/MM/YYYY"));
                      setFieldValue('toDate', e[1] ? moment(e[1]).format("DD/MM/YYYY") : '');
                    }}
                  />
                </div> */}
                    <div className="col-md-3">
                      <label htmlFor="" className='form_label'>From Date</label>

                      <Flatpickr
                        className='form_input form-control'
                        name='fromDate'
                        // value={values?.fromDate || new Date().toISOString()}
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: 'm-d-Y', // Customize date format as needed
                          minDate: '', // Before dates disabled
                          maxDate: '', // After dates disabled
                          disable: [], // Disable particular date ranges
                          mode: "single", //multiple-single-range
                          defaultDate: [], // Use today's date as default if none selected
                          conjunction: "", // Multiple dates separation
                        }}
                        onChange={(e) => {
                          setFieldValue('fromDate', moment(e[0]).format("DD/MM/YYYY"))
                        }}
                        onBlur={handleBlur}
                      />

                    </div>
                    <div className="col-md-3">
                      <label htmlFor="" className='form_label'>To Date</label>

                      <Flatpickr
                        className='form_input form-control'
                        name='toDate'
                        // value={values?.toDate || new Date().toISOString()}
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: 'm-d-Y', // Customize date format as needed
                          minDate: '', // Before dates disabled
                          maxDate: '', // After dates disabled
                          disable: [], // Disable particular date ranges
                          mode: "single", //multiple-single-range
                          defaultDate: [], // Use today's date as default if none selected
                          conjunction: "", // Multiple dates separation
                        }}
                        onChange={(e) => {
                          setFieldValue('toDate', moment(e[0]).format("DD/MM/YYYY"))
                        }}
                        onBlur={handleBlur}
                      />

                    </div>
                    <div className="col-md-3">
                      <div className='d-flex align-items-center mt-4 mb-1'>
                        <SaveButton name={'Filter'} />
                        <button className='ms-1 refresh_btn' onClick={handleReset} ><IoRefreshOutline style={{ color: 'white' }} size={25} /></button>
                      </div>
                    </div>
                  </div>
                </form>
                <div >
                  {
                    filterLoad ?
                      <div>
                        <Loader />
                      </div> :
                      orderList && orderList.length ?
                        <div className='mt-2'>
                          <DataTablePagination
                            rowData={orderList}
                            columnDefs={columnDefs}
                            height={'65vh'}
                            loading={tableLoading}
                          />
                          <div className='text-end pgn_tbl_footer mb-2'>
                            <div className='d-flex justify-content-end align-items-center'>
                              <div className="d-flex align-items-center">
                                <label htmlFor="" className="form-label form_label" style={{ marginBottom: 0 }}>Page Size</label>
                                <select className="form-select form_input ms-2" style={{ width: '12vh' }} onChange={(e) => { PageSizeFun(e.target.value); }}>
                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <option value="150">150</option>
                                  <option value="200">200</option>
                                </select>
                              </div>
                              <div className='d-flex align-items-center ms-3 table_footer_pagination' style={{ marginRight: '15px' }}>
                                <button type='button' disabled={pageSize === 1 ? true : false} onClick={() => { prevPageFun() }} className='btn pg_btn'><span className='me-2'><LuChevronLeft style={{ marginBottom: '2px' }} size={20} /></span></button>
                                <p><span>{pageLimit * pageSize - pageLimit + 1}</span> to <span>{pageLimit * pageSize - pageLimit + orderList?.length}</span></p>
                                <button type='button' disabled={orderList?.length < pageLimit ? true : false} onClick={() => { nextPageFun() }} className='btn pg_btn'>   <span className='ms-2'><LuChevronRight style={{ marginBottom: '2px' }} size={20} /></span></button>
                              </div>
                            </div>
                          </div>
                        </div> :
                        <div className='empty_section mt-3'>
                          <span>DATA NOT FOUND</span>
                        </div>
                  }
                </div>
              </div>}
          </div>
        </div>
      </div>
      <DeleteOrder deleteModal={deleteModal} setDeleteModal={setDeleteModal} orderData={orderData} bool={bool} setBool={setBool} />
      <ToastContainer />
    </>
  )
}
